import { makeAutoObservable } from 'mobx'
import { type IRowBase } from 'shared/ui/TableNew'
import { type TableColumnsStore } from 'shared/ui/TableNew/store/tableColumnsStore'

type ICacheColumns = {
  [key in string]: string[]
}

export class TableColumnsCacheStore<TRow extends IRowBase = IRowBase> {
  private readonly _cacheKey: string

  constructor(private _tableColumnsStore: TableColumnsStore<TRow>) {
    this._cacheKey = `table_visible_columns_cache_${window.localStorage.getItem('user_id')}`

    makeAutoObservable(this)
  }

  get config() {
    return this._tableColumnsStore.config
  }

  getCache = () => {
    const cache = window.localStorage.getItem(this._cacheKey)

    if (!cache) return []

    const keyTable = this.config.key
    const data = JSON.parse(cache) as ICacheColumns

    return data[keyTable] || []
  }

  addCache = (ids: string[]) => {
    const cache = window.localStorage.getItem(this._cacheKey)
    let data: ICacheColumns = {}
    const keyTable = this.config.key

    if (!cache) {
      data = {
        [keyTable]: ids,
      }
    } else {
      data = {
        ...JSON.parse(cache),
        [keyTable]: ids,
      }
    }

    window.localStorage.setItem(this._cacheKey, JSON.stringify(data))
  }

  deleteCache = () => {
    const cache = window.localStorage.getItem(this._cacheKey)

    if (!cache) return

    const keyTable = this.config.key
    const data = JSON.parse(cache)

    delete data[keyTable]

    window.localStorage.setItem(this._cacheKey, JSON.stringify(data))
  }
}
